import { render, staticRenderFns } from "./App.vue?vue&type=template&id=edf7b8cc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=edf7b8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../PO_APP_Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf7b8cc",
  null
  
)

export default component.exports